import groq from 'groq'

import { callToAction } from '../../../projections/callToAction.js'

export const header = groq`
  _type,
  title,
  subtitle,
  "updatedAt": ^._updatedAt,
  sideCta{
    "title": coalesce(
      title,
      *[_type == 'sharedContent'][0].articles.callToActionTitle
    ),
    cta{...${callToAction()}}
  }
`
